<div class="container-detail">

  <!-- DESCRIPCIÓN -->
  <div class="row mx-0">

   <div class="py-4 py-lg-5 px-3 px-lg-5 col-12 col-md-6">
      <h4><strong>Ubicación del proyecto</strong></h4>

      <div class="d-flex mb-3">
        <svg class="my-auto me-2" width="15" height="18" viewBox="0 0 15 18" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.728 12.7279L7.45585 18L2.18374 12.7279C1.14103 11.6852 0.430937 10.3567 0.143259 8.91037C-0.144419 7.46408 0.00323654 5.96497 0.567554 4.60259C1.13187 3.24022 2.08751 2.07578 3.31361 1.25653C4.53972 0.437275 5.98122 0 7.45585 0C8.93047 0 10.372 0.437275 11.5981 1.25653C12.8242 2.07578 13.7798 3.24022 14.3441 4.60259C14.9085 5.96497 15.0561 7.46408 14.7684 8.91037C14.4808 10.3567 13.7707 11.6852 12.728 12.7279ZM7.45585 9.11263C7.89527 9.11263 8.3167 8.93807 8.62742 8.62735C8.93814 8.31663 9.1127 7.8952 9.1127 7.45578C9.1127 7.01635 8.93814 6.59493 8.62742 6.28421C8.3167 5.97349 7.89527 5.79893 7.45585 5.79893C7.01642 5.79893 6.595 5.97349 6.28427 6.28421C5.97355 6.59493 5.79899 7.01635 5.79899 7.45578C5.79899 7.8952 5.97355 8.31663 6.28427 8.62735C6.595 8.93807 7.01642 9.11263 7.45585 9.11263Z"
            fill="#860067" />
        </svg>
        <p class="fw-light cl-sec-purple fw-sbold mb-0" [innerHtml]="dev.address"></p>
      </div>

      <div class="mb-1 fs-14" [innerHtml]="locationDescription || locationProject"></div>

      <div class="d-flex cl-primary-7 fs-22 social" *ngIf="dev.social">
        <fa-icon [icon]="icons.fb" *ngIf="dev.social.fb"></fa-icon>
        <fa-icon [icon]="icons.tw" *ngIf="dev.social.tw"></fa-icon>
        <fa-icon [icon]="icons.ig" *ngIf="dev.social.ig"></fa-icon>
        <fa-icon [icon]="icons.yt" *ngIf="dev.social.yt"></fa-icon>
      </div>
    </div>

    <div class="container-map col-12 col-md-6 px-0">
      <a [href]="googleMapRoute" target="_blank" rel="noopener noreferrer">
        <google-map height="180px" [options]="mapOptions" [center]="mapCenter" [zoom]="13">
          <map-marker [position]="mapCenter" [title]="dev.name">
          </map-marker>
        </google-map>
      </a>
    </div>

  </div>
  <!-- END | DESCRIPCIÓN -->


  <!-- CONTENEDOR CARACTERÍSTICAS DEL DESTINO -->
  <div class="bg-blue" *ngIf="dev.location.description">
    <div class="d-flex flex-column flex-md-row justify-content-between">
      <div class="py-4 py-lg-5 px-3 px-lg-5">
        <h5>{{ dev.location?.name }}</h5>
        <h4><strong>Destino turístico</strong></h4>
        <div [innerHtml]="descriptionTurism"></div>
        <!-- SECCIÓN DE EXITO DE INVERSIÓN -->
        <div *ngIf="dev?.devInfoDetail?.locationList" class="mt-5">
          <h4><strong>Conoce el éxito de una inversión en Tulum</strong></h4>
          <ul class="m-0">
            <li *ngFor="let item of dev?.devInfoDetail?.locationList">
              <div [innerHTML]="item"></div>
            </li>
          </ul>
        </div>
        <!-- END SECCION EXITO DE INVERSIÓN -->

        <!-- SECCIÓN BOTON DE EBOOK -->
        <div class="d-flex align-items-center justify-content-center justify-content-md-end" *ngIf="dev?.devInfoDetail?.ebookLink">
          <button class="btn-space" (click)="openLink(dev?.devInfoDetail?.ebookLink)" mat-button>Descargar ebook</button>
        </div>
        <!-- END SECCION BOTON EBOOK -->

      </div>

      <img [src]="imageLocation" class="location-img" alt="">
    </div>
  </div>
  <!-- END | CARACTERÍSTICAS DEL DESTINO -->

  <!-- PREMIOS -->
  <div class="py-4 py-lg-5 px-3 px-lg-5 text-center" *ngIf="dev.location.rewards">
    <h5 class="ms-2">¿Por qué {{ dev.location?.name }}?</h5>
    <h4><strong>Premios y menciones</strong></h4>

    <div class="row justify-content-center mt-4">
      <div class="col-6 col-sm-4 col-lg-3 col-xl-2 mb-3" *ngFor="let r of rewards">
        <div class="reward-container">
          <div class="img-container">
            <img [src]="r.img" alt="">
          </div>
          <p mat-raised-button #tooltip="matTooltip" [matTooltip]="r.title" class="text-truncate--4" [innerHTML]="r.title"></p>
        </div>
      </div>
    </div>
  </div>
  <!-- END | PREMIOS -->


  <!-- ESTADÍSTICAS -->
  <div class="bg-blue" *ngIf="dev.location.averageStatistics && dev.location.occupationStatistics && dev.location.occupation && dev.location.foreignDesc">
    <div class="container py-4 py-lg-5 px-3 px-lg-5">
      <h5 class="ms-2 text-center">{{ dev.location?.name }}</h5>
      <h4 class="text-center mb-4"><strong>Estadísticas</strong></h4>

      <div class="row">
        <div class="col-12 mb-4">
          <div class="container-stats d-flex">
            <div class="row">
              <div class="col-12 col-md-6">
                <h4><strong>Ocupación hotelera</strong></h4>
                <div class="fw-light text-fix" [innerHtml]="descriptionOccupation"></div>
                <!-- <a class="fw-sbold fs-14" [href]="'https://google.com'" target="_blank" rel="noopener">Ir a referencia
                  <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.90056 4L0.6875 8V0L4.90056 4Z" fill="#860067" />
                  </svg>
                </a> -->
              </div>
              <div class="col-12 col-md-6">
                <div class="container-countries">
                  <canvas id="occupation-chart"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END | ESTADÍSTICAS -->

        <!-- OCUPACIÓN ANUAL -->
        <div class="col-6 col-lg-3 mb-4" *ngFor="let occupation of occupationStatistics">
          <div class="container-estadistic" [innerHtml]="occupation"></div>
        </div>
        <!-- END | OCUPACIÓN ANUAL -->

        <!-- ORIGEN DE VISITAS -->
        <div class="col-12 mb-4" *ngIf="descriptionForeign">
          <div class="container-stats d-flex">
            <div class="row">
              <div class="col-12 col-md-6">
                <h4><strong>Origen de visitas</strong></h4>
                <div class="fw-light" [innerHtml]="descriptionForeign"></div>
                <!-- <a class="fw-sbold fs-14" [href]="'https://google.com'" target="_blank">Ir a referencia
                  <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.90056 4L0.6875 8V0L4.90056 4Z" fill="#860067" />
                  </svg>
                </a> -->
              </div>
              <div class="col-12 col-md-6">
                <div class="container-countries">
                  <canvas id="countries-chart"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END | ORIGEN DE VISITAS -->

        <!-- ESTADÍSTICAS -->
        <div class="col-6 col-lg-3 mb-3 mb-lg-0 mx-auto" *ngFor="let ave of dev.location?.averageStatistics">
          <div class="container-estadistic" [innerHtml]="ave"></div>
        </div>
        <!-- END | ESTADÍSTICAS -->

      </div>
    </div>
  </div>
  <!-- END | ESTADÍSTICAS -->
</div>
